import React from "react";
import "../LogoutConfirm/LogoutConfirm.css";
import { useNavigate } from "react-router-dom";

export default function LogoutConfirm() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("seller_token");
    localStorage.removeItem("user_token");
    localStorage.removeItem("seller_user");
    localStorage.removeItem("user");

    navigate("/login");
  };

  return (
    <div className="logout-wrapper container pt-4">

      <div className="logout-content mt-5">
        <h2 className="logout-title mt-5">
          هل تريد تسجيل الخروج ؟
        </h2>

        <button
          className="logout-main-btn2"
          onClick={handleLogout}
        >
          تسجيل الخروج
        </button>

      </div>
    </div>
  );
}
